import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../App";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CourseCard from "../components/CourseCard";
import PromotionCard from "../components/PromotionCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Label } from "../components/ui/label";

const Courses = () => {
  const { API } = useAuth();
  const [searchParams] = useSearchParams();
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    category: "all",
    level: "all",
    tier: "all",
  });

  useEffect(() => {
    fetchCourses();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [courses, filters, searchParams]);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${API}/courses`);
      setCourses(response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...courses];
    const search = searchParams.get("search");

    if (search) {
      filtered = filtered.filter(
        (course) =>
          course.title.toLowerCase().includes(search.toLowerCase()) ||
          course.description.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (filters.category && filters.category !== "all") {
      filtered = filtered.filter((course) => course.category === filters.category);
    }

    if (filters.level && filters.level !== "all") {
      filtered = filtered.filter((course) => course.level === filters.level);
    }

    if (filters.tier && filters.tier !== "all") {
      filtered = filtered.filter((course) => course.tier === filters.tier);
    }

    setFilteredCourses(filtered);
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-24">
        <h1 className="text-4xl md:text-5xl font-black text-white mb-8">Catálogo de Cursos</h1>

        {/* Promo destacada */}
        <div className="mb-8">
          <PromotionCard />
        </div>

        {/* Filters */}
        <div className="bg-card/50 backdrop-blur-md border border-white/10 rounded-lg p-6 mb-8">
          <h2 className="text-white font-semibold mb-4">Filtros</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <Label className="text-white mb-2 block">Categoría</Label>
              <Select
                value={filters.category || "all"}
                onValueChange={(value) => setFilters({ ...filters, category: value === "all" ? "" : value })}
              >
                <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="filter-category">
                  <SelectValue placeholder="Todas" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todas</SelectItem>
                  <SelectItem value="Contabilidad">Contabilidad</SelectItem>
                  <SelectItem value="Tributación">Tributación</SelectItem>
                  <SelectItem value="Laboral">Laboral</SelectItem>
                  <SelectItem value="Finanzas">Finanzas</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="text-white mb-2 block">Nivel</Label>
              <Select
                value={filters.level || "all"}
                onValueChange={(value) => setFilters({ ...filters, level: value === "all" ? "" : value })}
              >
                <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="filter-level">
                  <SelectValue placeholder="Todos" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos</SelectItem>
                  <SelectItem value="Básico">Básico</SelectItem>
                  <SelectItem value="Intermedio">Intermedio</SelectItem>
                  <SelectItem value="Avanzado">Avanzado</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label className="text-white mb-2 block">Tipo</Label>
              <Select
                value={filters.tier || "all"}
                onValueChange={(value) => setFilters({ ...filters, tier: value === "all" ? "" : value })}
              >
                <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="filter-tier">
                  <SelectValue placeholder="Todos" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos</SelectItem>
                  <SelectItem value="GRATIS">GRATIS</SelectItem>
                  <SelectItem value="PRO">PRO</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        {/* Course Grid */}
        {loading ? (
          <div className="text-center text-white py-20">Cargando cursos...</div>
        ) : filteredCourses.length === 0 ? (
          <div className="text-center text-white/60 py-20">
            <p className="text-xl">No se encontraron cursos</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="courses-grid">
            {filteredCourses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Courses;
